module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/configuration-3b7157b5d5f4647388b4b1a04a57be4b.svg";